module.exports = __webpack_public_path__ + "h5/img/bs_16.6dd84a83.jpeg";